const THEME_VARS = {
    '--theme-primary-color': 'primaryColor',
    '--theme-secondary-color': 'secondaryColor',
    '--theme-font-family': 'fontFamily',
    '--theme-modal-background': 'modalBackgroundColor',
    '--theme-modal-radius': 'modalBorderRadius',
    '--theme-overlay-color': 'overlayColor',
    '--theme-header-color': 'headerColor',
    '--theme-navbar-color': 'navbarColor',
    '--theme-stepper-background': 'stepperBgColor',
};

export const themeVars = (config = {}) => {
    const vars = Object.entries(THEME_VARS).reduce((applied, [cssVar, configKey]) => {
        if (config[configKey]) {
            applied[cssVar] = config[configKey];
        }

        return applied;
    }, {});

    if (config.button?.borderRadius) {
        vars['--theme-button-radius'] = config.button.borderRadius;
    }

    return vars;
};

// Variants are style sets, not values, so the screen CSS selects on them.
export const themeAttrs = (config = {}) => ({
    'data-button-variant': config.button?.variant || 'contained',
    'data-input-variant': config.textInputVariant || 'outlined',
});
